import DOMPurify from 'dompurify';

const HTML_TAG_PATTERN = /<\/?[a-z][\s\S]*>/i;

export function escapeHtml(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

export function htmlToPlainText(value: string | null | undefined): string {
  const raw = String(value || '').trim();
  if (!raw) return '';
  return raw
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/p>/gi, '\n')
    .replace(/<\/div>/gi, '\n')
    .replace(/<[^>]+>/g, '')
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/gi, '&')
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')
    .replace(/&quot;/gi, '"')
    .replace(/&#39;/gi, "'")
    .replace(/[ \t]+\n/g, '\n')
    .replace(/\n{2,}/g, '\n')
    .replace(/[ \t]{2,}/g, ' ')
    .trim();
}

export function renderDescriptionHtml(value: string | null | undefined): string {
  const raw = String(value || '').trim();
  if (!raw) return '';
  // Descriptions are rendered with dangerouslySetInnerHTML (incl. the public /q/:token page),
  // so strip scripts, event handlers and javascript: URLs while keeping formatting.
  if (HTML_TAG_PATTERN.test(raw)) return DOMPurify.sanitize(raw);

  return raw
    .split(/\n{2,}/)
    .map((paragraph) => `<p>${escapeHtml(paragraph).replace(/\n/g, '<br />')}</p>`)
    .join('');
}

export function normalizeDescriptionTemplateMarkup(templateHtml: string): string {
  return templateHtml
    .replace(/<p[^>]*>\s*\{\{description\}\}\s*<\/p>/gi, '{{description}}')
    .replace(/<div[^>]*>\s*\{\{description\}\}\s*<\/div>/gi, '{{description}}');
}

export function applyDescriptionTemplateText(
  currentValue: string,
  templateText: string,
  mode: 'use' | 'append',
): string {
  const nextHtml = renderDescriptionHtml(templateText);
  if (mode === 'use' || !String(currentValue || '').trim()) return nextHtml;
  return `${renderDescriptionHtml(currentValue)}${nextHtml}`;
}
